import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as actionsUi from './checklisten.actions.ui';
import * as apiVorlagen from '../../../clients/vorlagen';
import {Aufgabe, Checkliste, ChecklisteDetail, FunktionsbereichChecklisten, FunktionsbereichRolle, VeranstaltungsTyp} from '../../../clients/vorlagen';
import * as apiBenutzerverwaltung from '../../../clients/benutzerverwaltung';
import {Funktionsbereich} from '../../../clients/benutzerverwaltung';
import {
    GET_CHECKLISTE_DETAIL,
    GET_CHECKLISTE_AUFGABEN,
    GET_CHECKLISTE_AUFGABEN_ERFOLGREICH,
    GET_CHECKLISTE_AUFGABEN_FEHLER,
    GET_CHECKLISTE_DETAIL_ERFOLGREICH,
    GET_CHECKLISTE_DETAIL_FEHLER,
    GET_FUNKTIONSBEREICHE_CHECKLISTEN,
    GET_FUNKTIONSBEREICHE_CHECKLISTEN_ERFOLGREICH,
    GET_FUNKTIONSBEREICHE_CHECKLISTEN_FEHLER,
    GetChecklisteAufgabenErfolgreichAction,
    GetChecklisteAufgabenFehlerAction,
    GetChecklisteDetailErfolgreichAction,
    GetChecklisteDetailFehlerAction,
    GetFunktionsbereicheChecklistenErfolgreichAction,
    GetFunktionsbereicheChecklistenFehlerAction,
    POST_AUFGABE_AKTUALISIEREN,
    POST_AUFGABE_AKTUALISIEREN_ERFOLGREICH,
    POST_AUFGABE_AKTUALISIEREN_FEHLER,
    POST_AUFGABE_ANLEGEN,
    POST_AUFGABE_ANLEGEN_ERFOLGREICH,
    POST_AUFGABE_ANLEGEN_FEHLER,
    POST_AUFGABE_LOESCHEN,
    POST_AUFGABE_LOESCHEN_ERFOLGREICH,
    POST_AUFGABE_LOESCHEN_FEHLER,
    POST_CHECKLISTE_AKTUALISIEREN,
    POST_CHECKLISTE_AKTUALISIEREN_ERFOLGREICH,
    POST_CHECKLISTE_AKTUALISIEREN_FEHLER,
    POST_CHECKLISTE_ANLEGEN,
    POST_CHECKLISTE_ANLEGEN_ERFOLGREICH,
    POST_CHECKLISTE_ANLEGEN_FEHLER,
    POST_CHECKLISTE_LOESCHEN,
    POST_CHECKLISTE_LOESCHEN_ERFOLGREICH,
    POST_CHECKLISTE_LOESCHEN_FEHLER,
    PostAufgabeAktualisierenAction,
    PostAufgabeAktualisierenFehlerAction,
    PostAufgabeAnlegenAction,
    PostAufgabeAnlegenFehlerAction,
    PostAufgabeLoeschenAction,
    PostAufgabeLoeschenFehlerAction,
    PostChecklisteAktualisierenAction,
    PostChecklisteAktualisierenFehlerAction,
    PostChecklisteAnlegenAction,
    PostChecklisteAnlegenFehlerAction,
    PostChecklisteLoeschenAction,
    PostChecklisteLoeschenFehlerAction, PostAufgabeReihenfolgenAction, POST_AUFGABE_REIHENFOLGEN, POST_AUFGABE_REIHENFOLGEN_ERFOLGREICH
} from '../../../client-ngrx/vorlagen';
import {
    GET_CHECKLISTE_PANDEMIE_LEVEL_INFO,
    GET_CHECKLISTE_PANDEMIE_LEVEL_INFO_ERFOLGREICH,
    GET_CHECKLISTE_PANDEMIE_LEVEL_INFO_FEHLER,
    GetChecklistePandemieLevelInfoErfolgreichAction,
    GetChecklistePandemieLevelInfoFehlerAction
} from '../../../client-ngrx/pandemie';
import {ChecklistePandemieLevelInfo, PandemieMandantOptions} from '../../../clients/pandemie';
import {AufgabePandemieLevel, AufgabePandemieLevelListeAnzeigeItem, AufgabePandemieLevelListItem} from './checklisten.models';
import {getIstPandemieLizenzAktiv, getPandemieMandantOptions} from '@orga-app/mandant/reducer';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {AKTUELLE_CHECKLISTE_TYPEN_SETZEN, AktuelleChecklisteTypenSetzenAction} from './checklisten.actions.ui';


export interface RollenWrapper {
    id: string;
    titel: string;
    aktiv: boolean;
}

export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    // FUNKTIONSBEREICHE CHECKLISTEN (LISTE)
    funktionsbereicheChecklistenListe: Array<apiVorlagen.FunktionsbereichChecklisten>;
    funktionsbereicheChecklistenListeUiLaden: boolean;
    funktionsbereicheChecklistenListeUiFehler: boolean;
    funktionsbereicheChecklistenListeUiFehlerObjekt: any;

    // FUNKTIONSBEREICHE (LISTE)
    funktionsbereichListeUiSelektiert: Funktionsbereich;

    // CHECKLISTEN (LISTE)
    checklisteListeUiSelektiert: Checkliste;

    // AUFGABEN (LISTE)
    aufgabeListe: Array<Aufgabe>;
    aufgabeListeUiLaden: boolean;
    aufgabeListeUiFehler: boolean;
    aufgabeListeUiFehlerObjekt: any;
    aufgabeListeUiSelektiert: Aufgabe;
    aufgabeListeSelektiert: string;

    // FUNKTIONSBEREICHE (DETAIL)
    funktionsbereichDetail: apiBenutzerverwaltung.FunktionsbereichDetail;
    funktionsbereichDetailUiLaden: boolean;
    funktionsbereichDetailUiFehler: boolean;
    funktionsbereichDetailUiFehlerObjekt: any;

    // CHECKLISTEN (DETAIL)
    checklisteDetail: apiVorlagen.ChecklisteDetail;
    checklisteDetailUiLaden: boolean;
    checklisteDetailUiFehler: boolean;
    checklisteDetailUiFehlerObjekt: any;

    veranstaltungsTypenSelected: Array<string>;

    // CHECKLISTE LOESCHEN (COMMANDS)
    checklisteLoeschenCmdUi: boolean;
    checklisteLoeschenCmdUiErfolgreich: boolean;
    checklisteLoeschenCmdUiFehler: boolean;
    checklisteLoeschenCmdUiFehlerObjekt: any;

    // CHECKLISTE ANLEGEN (COMMANDS)
    checklisteAnlegenCmdUi: boolean;
    checklisteAnlegenCmdUiErfolgreich: boolean;
    checklisteAnlegenCmdUiFehler: boolean;
    checklisteAnlegenCmdUiFehlerObjekt: any;

    // CHECKLISTE AKTUALISIEREN (COMMANDS)
    checklisteAktualisierenCmdUi: boolean;
    checklisteAktualisierenCmdUiErfolgreich: boolean;
    checklisteAktualisierenCmdUiFehler: boolean;
    checklisteAktualisierenCmdUiFehlerObjekt: any;

    // AUFGABE LOESCHEN (COMMANDS)
    aufgabeLoeschenCmdUi: boolean;
    aufgabeLoeschenCmdUiErfolgreich: boolean;
    aufgabeLoeschenCmdUiFehler: boolean;
    aufgabeLoeschenCmdUiFehlerObjekt: any;

    // AUFGABE ANLEGEN (COMMANDS)
    aufgabeAnlegenCmdUi: boolean;
    aufgabeAnlegenCmdUiErfolgreich: boolean;
    aufgabeAnlegenCmdUiFehler: boolean;
    aufgabeAnlegenCmdUiFehlerObjekt: any;

    // AUFGABE AKTUALISIEREN (COMMANDS)
    aufgabeAktualisierenCmdUi: boolean;
    aufgabeAktualisierenCmdUiErfolgreich: boolean;
    aufgabeAktualisierenCmdUiFehler: boolean;
    aufgabeAktualisierenCmdUiFehlerObjekt: any;

    // Berechtigungen
    freigabeRollenSelektiert: Array<string>;
    abarbeitenRollenSelektiert: Array<string>;
    leseRollenSelektiert: Array<string>;

    // Pandemie
    checklistePandemieLevelInfo: ChecklistePandemieLevelInfo;
    checklistePandemieLevelInfoLaden: boolean;
    checklistePandemieLevelInfoFehler: boolean;
    checklistePandemieLevelInfoFehlerObjekt: any;
}

export const initialPageState: PageState = {

    // FUNKTIONSBEREICHE CHECKLISTEN (LISTE)
    funktionsbereicheChecklistenListe: null,
    funktionsbereicheChecklistenListeUiLaden: false,
    funktionsbereicheChecklistenListeUiFehler: false,
    funktionsbereicheChecklistenListeUiFehlerObjekt: null,

    // FUNKTIONSBEREICHE / CHECKLISTE SELECTED
    funktionsbereichListeUiSelektiert: null,
    checklisteListeUiSelektiert: null,

    // AUFGABEN (LISTE)
    aufgabeListe: null,
    aufgabeListeUiLaden: false,
    aufgabeListeUiFehler: false,
    aufgabeListeUiFehlerObjekt: null,
    aufgabeListeUiSelektiert: null,
    aufgabeListeSelektiert: null,

    // FUNKTIONSBEREICHE (DETAIL)
    funktionsbereichDetail: null,
    funktionsbereichDetailUiLaden: false,
    funktionsbereichDetailUiFehler: false,
    funktionsbereichDetailUiFehlerObjekt: null,

    // CHECKLISTEN (DETAIL)
    checklisteDetail: null,
    checklisteDetailUiLaden: false,
    checklisteDetailUiFehler: false,
    checklisteDetailUiFehlerObjekt: null,

    veranstaltungsTypenSelected: [],

    // CHECKLISTE LOESCHEN (COMMANDS)
    checklisteLoeschenCmdUi: false,
    checklisteLoeschenCmdUiErfolgreich: false,
    checklisteLoeschenCmdUiFehler: false,
    checklisteLoeschenCmdUiFehlerObjekt: null,

    // CHECKLISTE ANLEGEN (COMMANDS)
    checklisteAnlegenCmdUi: false,
    checklisteAnlegenCmdUiErfolgreich: false,
    checklisteAnlegenCmdUiFehler: false,
    checklisteAnlegenCmdUiFehlerObjekt: null,

    // CHECKLISTE AKTUALISIEREN (COMMANDS)
    checklisteAktualisierenCmdUi: false,
    checklisteAktualisierenCmdUiErfolgreich: false,
    checklisteAktualisierenCmdUiFehler: false,
    checklisteAktualisierenCmdUiFehlerObjekt: null,

    // AUFGABE LOESCHEN (COMMANDS)
    aufgabeLoeschenCmdUi: false,
    aufgabeLoeschenCmdUiErfolgreich: false,
    aufgabeLoeschenCmdUiFehler: false,
    aufgabeLoeschenCmdUiFehlerObjekt: null,

    // AUFGABE ANLEGEN (COMMANDS)
    aufgabeAnlegenCmdUi: false,
    aufgabeAnlegenCmdUiErfolgreich: false,
    aufgabeAnlegenCmdUiFehler: false,
    aufgabeAnlegenCmdUiFehlerObjekt: null,

    // AUFGABE AKTUALISIEREN (COMMANDS)
    aufgabeAktualisierenCmdUi: false,
    aufgabeAktualisierenCmdUiErfolgreich: false,
    aufgabeAktualisierenCmdUiFehler: false,
    aufgabeAktualisierenCmdUiFehlerObjekt: null,

    // Berechtigungen
    freigabeRollenSelektiert: [],
    abarbeitenRollenSelektiert: [],
    leseRollenSelektiert: [],

    checklistePandemieLevelInfo: null,
    checklistePandemieLevelInfoLaden: false,
    checklistePandemieLevelInfoFehler: false,
    checklistePandemieLevelInfoFehlerObjekt: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {

    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case POST_AUFGABE_REIHENFOLGEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                aufgabeListeUiLaden: true
            });
        }


        /* FUNKTIONSBEREICHE LISTE */
        case GET_FUNKTIONSBEREICHE_CHECKLISTEN: {
            return Object.assign({}, state, <PageState>{
                funktionsbereicheChecklistenListeUiLaden: true,
                funktionsbereicheChecklistenListeUiFehler: false,
                funktionsbereicheChecklistenListeUiFehlerObjekt: null
            });
        }

        case GET_FUNKTIONSBEREICHE_CHECKLISTEN_ERFOLGREICH: {
            const a = <GetFunktionsbereicheChecklistenErfolgreichAction>action;
            let newState = Object.assign({}, state, <PageState>{
                funktionsbereicheChecklistenListe: a.payload,
                funktionsbereicheChecklistenListeUiLaden: false,
                funktionsbereicheChecklistenListeUiFehler: false,
                funktionsbereicheChecklistenListeUiFehlerObjekt: null
            });

            if (state.funktionsbereichListeUiSelektiert != null && a.payload !== null) {
                let aktuellerFunktionsbereich = null;

                const res = a.payload.find((i) => i.funktionsbereich.funktionsbereich_id === state.funktionsbereichListeUiSelektiert.funktionsbereich_id);
                if (res) {
                    aktuellerFunktionsbereich = res.funktionsbereich;
                }


                if (aktuellerFunktionsbereich !== null) {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichListeUiSelektiert: aktuellerFunktionsbereich
                    });
                } else {
                    newState = Object.assign({}, newState, <PageState>{
                        funktionsbereichListeUiSelektiert: null
                    });
                }
            }

            return newState;
        }

        case GET_FUNKTIONSBEREICHE_CHECKLISTEN_FEHLER: {
            const a = <GetFunktionsbereicheChecklistenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                funktionsbereicheChecklistenListe: [],
                funktionsbereicheChecklistenListeUiLaden: false,
                funktionsbereicheChecklistenListeUiFehler: true,
                funktionsbereicheChecklistenListeUiFehlerObjekt: a.payload
            });
        }


        /* AUFGABEN (LISTE) */
        case GET_CHECKLISTE_AUFGABEN: {
            return Object.assign({}, state, <PageState>{
                aufgabeListeUiLaden: state.aufgabeListe === null,
                aufgabeListeUiFehler: false,
                aufgabeListeUiFehlerObjekt: null
            });
        }

        case GET_CHECKLISTE_AUFGABEN_ERFOLGREICH: {
            const a = <GetChecklisteAufgabenErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                aufgabeListe: a.payload,
                aufgabeListeUiLaden: false,
                aufgabeListeUiFehler: false,
                aufgabeListeUiFehlerObjekt: null
            });

            // if (state.aufgabeListeUiSelektiert != null && a.payload != null) {
            //     const aktuellSelektiert = a.payload.find(i => i.aufgabe_id === state.aufgabeListeUiSelektiert.aufgabe_id);
            //     if (aktuellSelektiert != null) {
            //         newState = Object.assign({}, newState, <PageState>{
            //             aufgabeListeUiSelektiert: aktuellSelektiert
            //         });
            //     } else {
            //         newState = Object.assign({}, newState, <PageState>{
            //             aufgabeListeUiSelektiert: null
            //         });
            //     }
            // }

            // return newState;
        }

        case GET_CHECKLISTE_AUFGABEN_FEHLER: {
            const a = <GetChecklisteAufgabenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                aufgabeListe: [],
                aufgabeListeUiLaden: false,
                aufgabeListeUiFehler: true,
                aufgabeListeUiFehlerObjekt: a.payload
            });
        }

        /* Pandemie Checklisten Aufgaben */
        case GET_CHECKLISTE_PANDEMIE_LEVEL_INFO: {
            return Object.assign({}, state, <PageState>{
                checklistePandemieLevelInfoFehler: false,
                checklistePandemieLevelInfoLaden: true
            });
        }

        case GET_CHECKLISTE_PANDEMIE_LEVEL_INFO_ERFOLGREICH: {
            const a = <GetChecklistePandemieLevelInfoErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                checklistePandemieLevelInfo: a.payload,
                checklistePandemieLevelInfoLaden: false,
                checklistePandemieLevelInfoFehler: false
            });
        }

        case GET_CHECKLISTE_PANDEMIE_LEVEL_INFO_FEHLER: {
            const a = <GetChecklistePandemieLevelInfoFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklistePandemieLevelInfo: null,
                checklistePandemieLevelInfoLaden: false,
                checklistePandemieLevelInfoFehler: true,
                checklistePandemieLevelInfoFehlerObjekt: a.payload
            });
        }


        /* CHECKLISTE (DETAIL) */
        case GET_CHECKLISTE_DETAIL: {
            return Object.assign({}, state, <PageState>{
                checklisteDetailUiLaden: true,
                checklisteDetailUiFehler: false,
                checklisteDetailUiFehlerObjekt: null
            });
        }

        case GET_CHECKLISTE_DETAIL_ERFOLGREICH: {
            const a = <GetChecklisteDetailErfolgreichAction>action;

            if (state.checklisteListeUiSelektiert && a.payload && state.checklisteListeUiSelektiert.checkliste_id === a.payload.checkliste_id) {
                return Object.assign({}, state, <PageState>{
                    checklisteDetail: a.payload,
                    checklisteDetailUiLaden: false,
                    checklisteDetailUiFehler: false,
                    checklisteDetailUiFehlerObjekt: null,
                });
            } else {
                return state;
            }
        }

        case GET_CHECKLISTE_DETAIL_FEHLER: {
            const a = <GetChecklisteDetailFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteDetail: null,
                checklisteDetailUiLaden: false,
                checklisteDetailUiFehler: true,
                checklisteDetailUiFehlerObjekt: a.payload
            });
        }

        case AKTUELLE_CHECKLISTE_TYPEN_SETZEN: {
            const a = <AktuelleChecklisteTypenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                veranstaltungsTypenSelected: a.payload
            });
        }


        /* CHECKLISTE LÖSCHEN (COMMAND) */
        case POST_CHECKLISTE_LOESCHEN: {
            return Object.assign({}, state, <PageState>{
                checklisteLoeschenCmdUi: true,
                checklisteLoeschenCmdUiErfolgreich: false,
                checklisteLoeschenCmdUiFehler: false,
                checklisteLoeschenCmdUiFehlerObjekt: null,
            });
        }

        case POST_CHECKLISTE_LOESCHEN_ERFOLGREICH: {
            const a = <PostChecklisteLoeschenAction>action;
            return Object.assign({}, state, <PageState>{
                checklisteDetail: null,
                checklisteListeUiSelektiert: null,
                checklisteLoeschenCmdUi: false,
                checklisteLoeschenCmdUiErfolgreich: true,
                checklisteLoeschenCmdUiFehler: false,
                checklisteLoeschenCmdUiFehlerObjekt: null,
            });
        }

        case POST_CHECKLISTE_LOESCHEN_FEHLER: {
            const a = <PostChecklisteLoeschenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteLoeschenCmdUi: false,
                checklisteLoeschenCmdUiFehler: true,
                checklisteLoeschenCmdUiFehlerObjekt: a.payload,
            });
        }

        /* CHECKLISTE ANLEGEN (COMMAND) */
        case POST_CHECKLISTE_ANLEGEN: {
            return Object.assign({}, state, <PageState>{
                checklisteAnlegenCmdUi: true,
                checklisteAnlegenCmdUiErfolgreich: false,
                checklisteAnlegenCmdUiFehler: false,
                checklisteAnlegenCmdUiFehlerObjekt: null,
            });
        }

        case POST_CHECKLISTE_ANLEGEN_ERFOLGREICH: {
            const a = <PostChecklisteAnlegenAction>action;
            return Object.assign({}, state, <PageState>{
                checklisteDetail: Object.assign({}, state.checklisteDetail, <apiVorlagen.Checkliste>{
                    checkliste_id: a.checklisteModelRequest.checkliste_id,
                    titel: a.checklisteModelRequest.titel,
                    funktionsbereich_id: a.checklisteModelRequest.funktionsbereich_id
                }),
                checklisteAnlegenCmdUi: false,
                checklisteAnlegenCmdUiErfolgreich: true,
                checklisteAnlegenCmdUiFehler: false,
                checklisteAnlegenCmdUiFehlerObjekt: null,
                checklisteListeUiSelektiert: <Checkliste>{checkliste_id: a.checklisteModelRequest.checkliste_id}
            });
        }

        case POST_CHECKLISTE_ANLEGEN_FEHLER: {
            const a = <PostChecklisteAnlegenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteAnlegenCmdUi: false,
                checklisteAnlegenCmdUiFehler: true,
                checklisteAnlegenCmdUiFehlerObjekt: a.payload,
            });
        }

        /* CHECKLISTE AKTUALISIEREN (COMMAND) */
        case POST_CHECKLISTE_AKTUALISIEREN: {
            return Object.assign({}, state, <PageState>{
                checklisteAktualisierenCmdUi: true,
                checklisteAktualisierenCmdUiErfolgreich: false,
                checklisteAktualisierenCmdUiFehler: false,
                checklisteAktualisierenCmdUiFehlerObjekt: null,
            });
        }

        case POST_CHECKLISTE_AKTUALISIEREN_ERFOLGREICH: {
            const a = <PostChecklisteAktualisierenAction>action;
            return Object.assign({}, state, <PageState>{
                checklisteAktualisierenCmdUi: false,
                checklisteAktualisierenCmdUiErfolgreich: true,
                checklisteAktualisierenCmdUiFehler: false,
                checklisteAktualisierenCmdUiFehlerObjekt: null,
            });
        }

        case POST_CHECKLISTE_AKTUALISIEREN_FEHLER: {
            const a = <PostChecklisteAktualisierenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteAktualisierenCmdUi: false,
                checklisteAktualisierenCmdUiFehler: true,
                checklisteAktualisierenCmdUiFehlerObjekt: a.payload,
            });
        }


        /* AUFGABE LÖSCHEN (COMMAND) */
        case POST_AUFGABE_LOESCHEN: {
            return Object.assign({}, state, <PageState>{
                aufgabeLoeschenCmdUi: true,
                aufgabeLoeschenCmdUiErfolgreich: false,
                aufgabeLoeschenCmdUiFehler: false,
                aufgabeLoeschenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_LOESCHEN_ERFOLGREICH: {
            const a = <PostAufgabeLoeschenAction>action;
            return Object.assign({}, state, <PageState>{
                aufgabeLoeschenCmdUi: false,
                aufgabeLoeschenCmdUiErfolgreich: true,
                aufgabeLoeschenCmdUiFehler: false,
                aufgabeLoeschenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_LOESCHEN_FEHLER: {
            const a = <PostAufgabeLoeschenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                aufgabeLoeschenCmdUi: false,
                aufgabeLoeschenCmdUiFehler: true,
                aufgabeLoeschenCmdUiFehlerObjekt: a.payload,
            });
        }

        /* AUFGABE ANLEGEN (COMMAND) */
        case POST_AUFGABE_ANLEGEN: {
            return Object.assign({}, state, <PageState>{
                aufgabeAnlegenCmdUi: true,
                aufgabeAnlegenCmdUiErfolgreich: false,
                aufgabeAnlegenCmdUiFehler: false,
                aufgabeAnlegenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_ANLEGEN_ERFOLGREICH: {
            const a = <PostAufgabeAnlegenAction>action;
            return Object.assign({}, state, <PageState>{
                aufgabeAnlegenCmdUi: false,
                aufgabeAnlegenCmdUiErfolgreich: true,
                aufgabeAnlegenCmdUiFehler: false,
                aufgabeAnlegenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_ANLEGEN_FEHLER: {
            const a = <PostAufgabeAnlegenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                aufgabeAnlegenCmdUi: false,
                aufgabeAnlegenCmdUiFehler: true,
                aufgabeAnlegenCmdUiFehlerObjekt: a.payload,
            });
        }

        /* AUFGABE AKTUALISIEREN (COMMAND) */
        case POST_AUFGABE_AKTUALISIEREN: {
            return Object.assign({}, state, <PageState>{
                aufgabeAktualisierenCmdUi: true,
                aufgabeAktualisierenCmdUiErfolgreich: false,
                aufgabeAktualisierenCmdUiFehler: false,
                aufgabeAktualisierenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_AKTUALISIEREN_ERFOLGREICH: {
            const a = <PostAufgabeAktualisierenAction>action;
            return Object.assign({}, state, <PageState>{
                aufgabeAktualisierenCmdUi: false,
                aufgabeAktualisierenCmdUiErfolgreich: true,
                aufgabeAktualisierenCmdUiFehler: false,
                aufgabeAktualisierenCmdUiFehlerObjekt: null,
            });
        }

        case POST_AUFGABE_AKTUALISIEREN_FEHLER: {
            const a = <PostAufgabeAktualisierenFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                aufgabeAktualisierenCmdUi: false,
                aufgabeAktualisierenCmdUiFehler: true,
                aufgabeAktualisierenCmdUiFehlerObjekt: a.payload,
            });
        }


        /* INTERNES COMMANDS */
        case actionsUi.NEUE_CHECKLISTE: {
            const a = <actionsUi.NeueChecklisteAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteListeUiSelektiert: a.payload,
                checklisteDetail: a.payload,
                aufgabeListe: null,
                // rolleListe: null,
                funktionsbereichDetail: null,
                funktionsbereichListeUiSelektiert: a.funktionsbereich
            });
        }

        case actionsUi.AKTUELLE_CHECKLISTE_SETZEN: {
            const a = <actionsUi.AktuelleChecklisteSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                checklisteListeUiSelektiert: a.payload,
                checklisteDetail: a.payload,
                abarbeitenRollenSelektiert: [],
                freigabeRollenSelektiert: [],
                leseRollenSelektiert: []
            });
        }

        case actionsUi.AKTUELLEN_FUNKTIONSBEREICH_GESETZT: {
            const a = <actionsUi.AktuellenFunktionsbereichSetzenAction>action;
            return Object.assign({}, state, <PageState>{
                funktionsbereichListeUiSelektiert: a.payload,
                // checklisteListeUiSelektiert: null
            });
        }

        case actionsUi.AKTUELLE_AUFGABE_GESETZT: {
            const a = <actionsUi.AktuelleAufgabeSetzenAction>action;
            return Object.assign({}, state, <PageState>{
                aufgabeListeSelektiert: a.payload.aufgabe_id
            });
        }


        /* ABARBEITUNGS-ROLLEN */
        case actionsUi.ABARBEITEN_ROLLEN_SETZEN: {
            const a = <actionsUi.AbarbeitenRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                abarbeitenRollenSelektiert: a.payload
            });
        }


        /* FREIGABE-ROLLEN */
        case actionsUi.FREIGABE_ROLLEN_SETZEN: {
            const a = <actionsUi.FreigabeRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                freigabeRollenSelektiert: a.payload
            });
        }


        /* LESE-ROLLEN */
        case actionsUi.LESE_ROLLEN_SETZEN: {
            const a = <actionsUi.LeseRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                leseRollenSelektiert: a.payload
            });
        }


        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('ChecklistenPage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// FUNKTIONSBEREICHE CHECKLISTEN (LISTE)

export const getFunktionsbereicheChecklistenListeUi = createSelector(getPageState, (state: PageState) => {
    if (state.funktionsbereicheChecklistenListe === null || state.funktionsbereicheChecklistenListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.funktionsbereicheChecklistenListe.forEach((fb) => {
            if (fb.checklisten.length > 0) {
                fb.checklisten.forEach(cl => {
                    res.push(<ListInputItem>{
                        groupId: fb.funktionsbereich.funktionsbereich_id,
                        groupTitle: fb.funktionsbereich.titel,
                        group: fb.funktionsbereich,
                        groupClass: 'funktionsbereiche',
                        itemId: cl.checkliste_id,
                        itemTitle: cl.titel,
                        item: {checkliste: cl, funktionsbereich: fb.funktionsbereich}
                    });
                });
            } else {
                res.push(<ListInputItem>{
                    groupId: fb.funktionsbereich.funktionsbereich_id,
                    groupTitle: fb.funktionsbereich.titel,
                    group: fb.funktionsbereich,
                    groupClass: 'funktionsbereiche',
                    itemId: null,
                    itemTitle: null,
                    item: null
                });
            }
        });
        return res;
    }
});


export const getFunktionsbereicheChecklistenListe = createSelector(getPageState, (state: PageState) => {
    if (state.funktionsbereicheChecklistenListe === null || state.funktionsbereicheChecklistenListe === undefined) {
        return [];
    } else {
        const funktionsbereicheChecklistenWrapped = [...state.funktionsbereicheChecklistenListe];
        return funktionsbereicheChecklistenWrapped.map((x) => {
            return <FunktionsbereichChecklisten>{
                funktionsbereich: x.funktionsbereich,
                checklisten: x.checklisten
            };
        }).sort((a, b) => {
            if (a.funktionsbereich.titel.toLowerCase() < b.funktionsbereich.titel.toLowerCase()) {
                return -1;
            }
            if (a.funktionsbereich.titel.toLowerCase() > b.funktionsbereich.titel.toLowerCase()) {
                return 1;
            }
            return 0;
        }).map(fb => {
            const checklistenWrapped = [...fb.checklisten];
            return Object.assign({}, fb, {
                checklisten: checklistenWrapped
                    .sort((a, b) => {
                        if (a && a.titel && b && b.titel && a.titel.toLowerCase() < b.titel.toLowerCase()) {
                            return -1;
                        }
                        if (a && a.titel && b && b.titel && a.titel.toLowerCase() > b.titel.toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    }).sort((a, b) => {
                        if (a.reihenfolge < b.reihenfolge) {
                            return -1;
                        }
                        if (a.reihenfolge > b.reihenfolge) {
                            return 1;
                        }
                        return 0;
                    })
            });
        });
    }
});
export const getFunktionsbereicheChecklistenListeUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereicheChecklistenListeUiLaden);
export const getFunktionsbereicheChecklistenListeUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereicheChecklistenListeUiFehler);
export const getFunktionsbereicheChecklistenListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereicheChecklistenListeUiFehlerObjekt);

export const getFunktionsbereicheIds = createSelector(getFunktionsbereicheChecklistenListe, (funktionsbereicheChecklisten: Array<apiVorlagen.FunktionsbereichChecklisten>) => {
    return funktionsbereicheChecklisten.map(x => x.funktionsbereich.funktionsbereich_id);
});

export const getFunktionsbereicheChecklistenIds = createSelector(getFunktionsbereicheChecklistenListeUi, (listInputItems: Array<ListInputItem>) => {
    return listInputItems.filter(item => item.itemId).map(item => item.itemId);
});

// export const getFunktionsbereicheChecklistenIds = createSelector(getFunktionsbereicheChecklistenListe, (funktionsbereicheChecklisten: Array<apiVorlagen.FunktionsbereichChecklisten>) => {
//     const checklistenIds = [];
//     funktionsbereicheChecklisten.forEach(x => {
//         x.checklisten.forEach(cl => checklistenIds.push(cl.checkliste_id));
//     });
//
//     return checklistenIds;
// });

export const getFunktionsbereicheUndChecklistenIds = createSelector(getFunktionsbereicheIds, getFunktionsbereicheChecklistenListe, (funktionsbereicheIds: Array<string>, funktionsbereicheChecklisten: Array<apiVorlagen.FunktionsbereichChecklisten>) => {
    const funktionsbereicheUndChecklistenIds = funktionsbereicheIds;
    funktionsbereicheChecklisten.forEach(x => {
        x.checklisten.forEach(cl => funktionsbereicheUndChecklistenIds.push(cl.checkliste_id));
    });

    return funktionsbereicheUndChecklistenIds;
});

// FUNKTIONSBEREICHE / CHECKLISTE SELECTED
export const getFunktionsbereichIdSelektiert = createSelector(getPageState, (state: PageState) => (state.funktionsbereichListeUiSelektiert) ? state.funktionsbereichListeUiSelektiert.funktionsbereich_id : null);
export const getChecklisteIdSelektiert = createSelector(getPageState, (state: PageState) => (state.checklisteListeUiSelektiert) ? state.checklisteListeUiSelektiert.checkliste_id : null);
export const getFunktionsbereichListeUiSelektiert = createSelector(getFunktionsbereicheChecklistenListe, getFunktionsbereichIdSelektiert, (funktionsbereichChecklistens: Array<apiVorlagen.FunktionsbereichChecklisten>, funktionsbereichIdSelektiert: string) => {
    const res = funktionsbereichChecklistens.find(x => x.funktionsbereich.funktionsbereich_id === funktionsbereichIdSelektiert);
    if (res) {
        return res.funktionsbereich;
    }
    return null;
});
export const getChecklisteListeUiSelektiert = createSelector(getFunktionsbereicheChecklistenListe, getChecklisteIdSelektiert,
    (funktionsbereichChecklistens: Array<apiVorlagen.FunktionsbereichChecklisten>, checklisteIdSelektiert: string) => {
    // console.log('FunktionsbereichChecklisten: ', funktionsbereichChecklistens);
    if (funktionsbereichChecklistens === null) {
        return null;
    }
    let res = null;
    // console.log('ChecklisteIdSelektiert: ', checklisteIdSelektiert);
    funktionsbereichChecklistens.forEach((item) => {
            const resCl = item.checklisten.find(cl => cl.checkliste_id === checklisteIdSelektiert);
            if (resCl) {
                res = resCl;
            }
        }
    );
    return res;
});

// AUFGABEN (LISTE)
export const getAufgabeListe = createSelector(getPageState, (state: PageState) => {
    if (state.aufgabeListe === null || state.aufgabeListe === undefined) {
        return [];
    } else {
        const aufgabenWrapped = [...state.aufgabeListe];
        return aufgabenWrapped
            .sort((a, b) => {
                if (a && a.titel && b && b.titel && a.titel.toLowerCase() < b.titel.toLowerCase()) {
                    return -1;
                }
                if (a && a.titel && b && b.titel && a.titel.toLowerCase() > b.titel.toLowerCase()) {
                    return 1;
                }
                return 0;
            }).sort((a, b) => {
                if (a.reihenfolge < b.reihenfolge) {
                    return -1;
                }
                if (a.reihenfolge > b.reihenfolge) {
                    return 1;
                }
                return 0;
            });
    }
});

export const getAufgabeListeUiLaden = createSelector(getPageState, (state: PageState) => state.aufgabeListeUiLaden);
export const getAufgabeListeUiFehler = createSelector(getPageState, (state: PageState) => state.aufgabeListeUiFehler);
export const getAufgabeListeUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.aufgabeListeUiFehlerObjekt);
export const getAufgabeListeSelektiert = createSelector(getPageState, (state: PageState) => state.aufgabeListeSelektiert);
export const getAufgabeListeUiSelektiert = createSelector(getAufgabeListe, getAufgabeListeSelektiert, (aufgaben: Array<apiVorlagen.Aufgabe>, aufgabeListeSelektiert: string) => {
    const res = aufgaben.find(x => x.aufgabe_id === aufgabeListeSelektiert);
    if (res) {
        return res;
    }
    return null;
});


// FUNKTIONSBEREICHE (DETAIL)
export const getFunktionsbereichDetail = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetail);
export const getFunktionsbereichDetailUiLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiLaden);
export const getFunktionsbereichDetailUiFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiFehler);
export const getFunktionsbereichDetailUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.funktionsbereichDetailUiFehlerObjekt);

// CHECKLISTEN (DETAIL)
export const getChecklisteDetail = createSelector(getPageState, (state: PageState) => state.checklisteDetail);
export const getChecklisteDetailUiLaden = createSelector(getPageState, (state: PageState) => state.checklisteDetailUiLaden);
export const getChecklisteDetailUiFehler = createSelector(getPageState, (state: PageState) => state.checklisteDetailUiFehler);
export const getChecklisteDetailUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.checklisteDetailUiFehlerObjekt);

export const getVeranstaltungsTypen = createSelector(getChecklisteDetail, (detail: ChecklisteDetail) => {
    if (detail === null || detail === undefined || detail.veranstaltungstyp_liste === null || detail.veranstaltungstyp_liste === undefined) {
        return [];
    }

    return detail.veranstaltungstyp_liste.map((item: VeranstaltungsTyp) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.veranstaltungstyp_id,
        itemTitle: item.bezeichnung,
        item: item
    });
});

export const getVeranstaltungsTypenSelected = createSelector(getPageState, (state: PageState) => state.veranstaltungsTypenSelected);

// PANDEMIE
export const getChecklistePandemieLevelInfo = createSelector(getPageState, (state: PageState) => state.checklistePandemieLevelInfo);
export const getChecklistePandemieLevelInfoLaden = createSelector(getPageState, (state: PageState) => state.checklistePandemieLevelInfoLaden);
export const getChecklistePandemieLevelInfoFehler = createSelector(getPageState, (state: PageState) => state.checklistePandemieLevelInfoFehler);
export const getChecklistePandemieLevelInfoFehlerObjekt = createSelector(getPageState, (state: PageState) => state.checklistePandemieLevelInfoFehlerObjekt);

// CHECKLISTE LOESCHEN (COMMANDS)
export const getChecklisteLoeschenCmdUi = createSelector(getPageState, (state: PageState) => state.checklisteLoeschenCmdUi);
export const getChecklisteLoeschenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.checklisteLoeschenCmdUiErfolgreich);
export const getChecklisteLoeschenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.checklisteLoeschenCmdUiFehler);
export const getChecklisteLoeschenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.checklisteLoeschenCmdUiFehlerObjekt);

// CHECKLISTE ANLEGEN (COMMANDS)
export const getChecklisteAnlegenCmdUi = createSelector(getPageState, (state: PageState) => state.checklisteAnlegenCmdUi);
export const getChecklisteAnlegenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.checklisteAnlegenCmdUiErfolgreich);
export const getChecklisteAnlegenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.checklisteAnlegenCmdUiFehler);
export const getChecklisteAnlegenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.checklisteAnlegenCmdUiFehlerObjekt);

// CHECKLISTE AKTUALISIEREN (COMMANDS)
export const getChecklisteAktualisierenCmdUi = createSelector(getPageState, (state: PageState) => state.checklisteAktualisierenCmdUi);
export const getChecklisteAktualisierenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.checklisteAktualisierenCmdUiErfolgreich);
export const getChecklisteAktualisierenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.checklisteAktualisierenCmdUiFehler);
export const getChecklisteAktualisierenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.checklisteAktualisierenCmdUiFehlerObjekt);

// AUFGABE LOESCHEN (COMMANDS)
export const getAufgabeLoeschenCmdUi = createSelector(getPageState, (state: PageState) => state.aufgabeLoeschenCmdUi);
export const getAufgabeLoeschenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.aufgabeLoeschenCmdUiErfolgreich);
export const getAufgabeLoeschenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.aufgabeLoeschenCmdUiFehler);
export const getAufgabeLoeschenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.aufgabeLoeschenCmdUiFehlerObjekt);

// AUFGABE ANLEGEN (COMMANDS)
export const getAufgabeAnlegenCmdUi = createSelector(getPageState, (state: PageState) => state.aufgabeAnlegenCmdUi);
export const getAufgabeAnlegenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.aufgabeAnlegenCmdUiErfolgreich);
export const getAufgabeAnlegenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.aufgabeAnlegenCmdUiFehler);
export const getAufgabeAnlegenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.aufgabeAnlegenCmdUiFehlerObjekt);

// AUFGABE AKTUALISIEREN (COMMANDS)
export const getAufgabeAktualisierenCmdUi = createSelector(getPageState, (state: PageState) => state.aufgabeAktualisierenCmdUi);
export const getAufgabeAktualisierenCmdUiErfolgreich = createSelector(getPageState, (state: PageState) => state.aufgabeAktualisierenCmdUiErfolgreich);
export const getAufgabeAktualisierenCmdUiFehler = createSelector(getPageState, (state: PageState) => state.aufgabeAktualisierenCmdUiFehler);
export const getAufgabeAktualisierenCmdUiFehlerObjekt = createSelector(getPageState, (state: PageState) => state.aufgabeAktualisierenCmdUiFehlerObjekt);

// BERECHTIGUNGEN
export const getFreigabeRollenSelektiert = createSelector(getPageState, (state: PageState) => state.freigabeRollenSelektiert);
export const getAbarbeitenRollenSelektiert = createSelector(getPageState, (state: PageState) => state.abarbeitenRollenSelektiert);
export const getLeseRollenSelektiert = createSelector(getPageState, (state: PageState) => state.leseRollenSelektiert);

export const getFreigabeRollen = createSelector(getChecklisteDetail,
    (checkliste: apiVorlagen.ChecklisteDetail): Array<ListInputItem> => {
    const freigabeRollen = [];
    if (checkliste !== null && checkliste.freigabe_rolle_liste !== null && checkliste.freigabe_rolle_liste !== undefined && checkliste.freigabe_rolle_liste.length > 0) {
        freigabeRollen.push(...checkliste.freigabe_rolle_liste);
    }

    return freigabeRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel,
        item: item
    });
});

export const getAbarbeitenRollen = createSelector(getChecklisteDetail, (checkliste: apiVorlagen.ChecklisteDetail): Array<ListInputItem> => {
    const abarbeitenRollen = [];
    if (checkliste !== null && checkliste.abarbeitung_rolle_liste !== null && checkliste.abarbeitung_rolle_liste !== undefined && checkliste.abarbeitung_rolle_liste.length > 0) {
        abarbeitenRollen.push(...checkliste.abarbeitung_rolle_liste);
    }

    return abarbeitenRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel,
        item: item
    });
});

export const getLeseRollen = createSelector(getChecklisteDetail, (checkliste: apiVorlagen.ChecklisteDetail): Array<ListInputItem> => {
    const leseRollen = [];
        if (checkliste !== null && checkliste.lese_rolle_liste !== null && checkliste.lese_rolle_liste !== undefined && checkliste.lese_rolle_liste.length > 0) {
            leseRollen.push(...checkliste.lese_rolle_liste);
        }

    return leseRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel,
        item: item
    });
});

export const getAufgabePandemieLevel = createSelector(getChecklistePandemieLevelInfo, getAufgabeListeUiSelektiert, getPandemieMandantOptions,
    (checklistePandemieLevelInfo: ChecklistePandemieLevelInfo, aufgabe: Aufgabe, pandemieMandantOptions: PandemieMandantOptions): Array<AufgabePandemieLevel> => {
        const result: Array<AufgabePandemieLevel> = [];

        if (pandemieMandantOptions !== null && pandemieMandantOptions !== undefined && pandemieMandantOptions.level.length > 0) {
            pandemieMandantOptions.level.forEach(x => {

                let ist_zugeordnet = false;
                if (checklistePandemieLevelInfo !== null && aufgabe !== null && checklistePandemieLevelInfo.aufgaben !== null) {

                    const aufgabePandemieLevelInfos = checklistePandemieLevelInfo.aufgaben.filter(z => z.aufgabe_id === aufgabe.aufgabe_id);

                    if (aufgabePandemieLevelInfos.findIndex(y => y.level_id === x.level_id) > -1) {
                        ist_zugeordnet = aufgabePandemieLevelInfos.find(y => y.level_id === x.level_id).ist_zugeordnet;
                    }
                }

                if (aufgabe !== null) {
                    result.push({
                        aufgabe_id: aufgabe.aufgabe_id,
                        ist_zugeordnet,
                        level_id: x.level_id,
                        level_anzeige: x.anzeige
                    });
                }
            });
        }

        return result;
    });

export const getAufgabeListePandemie = createSelector(getAufgabeListe, getChecklistePandemieLevelInfo, getPandemieMandantOptions, getIstPandemieLizenzAktiv, getFunktionsbereicheChecklistenIds,
    (aufgabeListe: Array<Aufgabe>, checklistePandemieLevelInfo: ChecklistePandemieLevelInfo, pandemieMandantOptions: PandemieMandantOptions, istPandemieLizenzAktiv: boolean, funktionsbereicheChecklistenIds: Array<string>): Array<ListInputItem> => {
        const result: Array<AufgabePandemieLevelListItem> = [];

        aufgabeListe.forEach(aufgabe => {
            const listeAnzeigeItem: Array<AufgabePandemieLevelListeAnzeigeItem> = [];
            if (istPandemieLizenzAktiv && pandemieMandantOptions !== null && pandemieMandantOptions !== undefined && pandemieMandantOptions.level.length > 0) {
                pandemieMandantOptions.level.forEach(levelOption => {

                    if (checklistePandemieLevelInfo !== null && checklistePandemieLevelInfo.aufgaben !== null) {
                        const aufgabePandemieLevelInfos = checklistePandemieLevelInfo.aufgaben.filter(z => z.aufgabe_id === aufgabe.aufgabe_id);

                        if (aufgabePandemieLevelInfos.findIndex(y => y.level_id === levelOption.level_id) > -1) {
                            listeAnzeigeItem.push({
                                farbe: levelOption.farbe,
                                icon: '/assets/svgicons/' + levelOption.icon + '.svg',
                                level_id: levelOption.level_id,
                                level_anzeige: levelOption.anzeige,
                                ist_zugeordnet: aufgabePandemieLevelInfos.find(y => y.level_id === levelOption.level_id).ist_zugeordnet
                            });
                        }
                    }
                });
            }
            const listItem: AufgabePandemieLevelListItem = {
                aufgabe,
                aufgabePandemieLevelListeAnzeige: listeAnzeigeItem
            };
            result.push(listItem);
        });

        // console.log('Result Aufgabenliste: ', result);
        const ret: Array<ListInputItem> = [];
        ret.push(...result.map((item: AufgabePandemieLevelListItem) => <ListInputItem>{
                groupId: '',
                groupTitle: '',
                groupClass: 'checklistenAufgaben dragAndDrop-list',
                cdkDropListConnectedTo: funktionsbereicheChecklistenIds,
                itemId: item.aufgabe.aufgabe_id,
                itemTitle: item.aufgabe.titel,
                item: item,
                cdkDragData: {item: item.aufgabe, model: 'Aufgabe'}
        }));

        return ret;
    });
